import styled from 'styled-components';
import InputSkeleton from '../components/input-skeleton';
import { Row } from '../../grid';

export const DateFieldSC = styled(Row)`
  display: inline-flex;
`;

export const SkeletonSC = styled(InputSkeleton)`
  flex: 1;
  :hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  }
`;

export const InputSC = styled.input`
  flex: 1;
  margin: 0;
  padding: 0;
  min-height: 100%;

  border: none;
  background: none;
  outline: none;
  box-shadow: none;

  :disabled,
  :read-only {
    cursor: not-allowed;
  }
`;
